<template>
  <div>
    <v-dialog ref="dialog" persitent v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          {{ text }}
          <div v-if="content">
            <span>{{ $t("confirmDialog.chooseBestTime") }} </span>
            <v-row dense class="mt-2">
              <v-col
                class="d-flex align-center justify-start"
                cols="12"
                v-for="(hour, index) in content"
                :key="index"
                style="height: auto"
              >
                <v-checkbox
                  v-model="selectedItems"
                  :key="index"
                  :label="
                    $t('confirmDialog.slotLabel', {
                      day: displayWeekDay(hour.weekDay),
                      from: hour.from,
                      to: hour.to,
                    })
                  "
                  :value="hour"
                  dense
                  :disabled="disableItems && !selectedItems.includes(hour)"
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <span style="font-size: 0.8rem">{{ selectionHint }}</span>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="selectedItems.length < minimumSelection"
            @click="confirm"
          >
            {{ $t("common.request") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { WEEK_DAY_ITEMS } from "@/shared/classPresentation";

export default {
  name: "confirmation-dialog",
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    item: {
      type: [Object, null],
    },
    content: {
      type: [Array, null],
    },
    limit: {
      type: Number,
    },
  },
  computed: {
    // `limit` chega 0 quando não há exigência de frequência (caso da aula
    // experimental, que é uma aula só). Sem o piso de 1, `0 < 0` liberava o
    // botão e dava para enviar a solicitação sem horário nenhum.
    minimumSelection() {
      return Math.max(1, Number(this.limit) || 0);
    },
    selectionHint() {
      if (this.minimumSelection === 1) {
        return this.$t("confirmDialog.hintAtLeastOne");
      }
      return this.$t("confirmDialog.hintMinimum", {
        count: this.minimumSelection,
      });
    },
  },
  data() {
    return {
      dialog: false,
      selectedItems: [],
      disableItems: false,
      days: WEEK_DAY_ITEMS,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$emit("cancel");
    },
    confirm() {
      let data = Object.assign({}, this.item);
      if (this.content.length > 0) {
        data["hours"] = this.selectedItems;
      }
      this.$emit("confirmed", data);
      this.dialog = false;
    },
    displayWeekDay(day) {
      return this.days.find((d) => d.value === +day).text;
    },
  },
};
</script>

<style lang="css" scoped></style>
